var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _circle, _circle2, _rect2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 400,
    viewBox: "0 0 566 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383H0V399.692H565.22V0.0317383Z",
    fill: "url(#paint0_linear_1375_1010)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1375_1010",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 566,
    height: 400
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383H0V399.692H565.22V0.0317383Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1375_1010)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-185.191 14.1536C65.9728 16.6189 187.642 -231.743 507.402 -117.114",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.338 19.0583C68.2836 22.1756 190.855 -226.929 510.517 -112.347",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181.485 23.9632C70.5934 27.7324 194.067 -222.116 513.63 -107.58",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-179.632 28.8679C72.9042 33.289 197.28 -217.303 516.745 -102.812",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.779 33.7727C75.2139 38.8457 200.493 -212.49 519.859 -98.0452",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-175.926 38.6775C77.5247 44.4025 203.706 -207.677 522.973 -93.2779",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-174.072 43.5822C79.8355 49.9591 206.919 -202.864 526.088 -88.5107",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.22 48.487C82.1453 55.5158 210.131 -198.051 529.201 -83.7434",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.366 53.3918C84.456 61.0726 213.345 -193.238 532.316 -78.9761",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168.513 58.2967C86.7668 66.6294 216.558 -188.424 535.43 -74.2087",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-166.66 63.2015C89.0766 72.1861 219.77 -183.611 538.544 -69.4415",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164.807 68.1063C91.3874 77.7429 222.983 -178.798 541.658 -64.6742",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-162.954 73.011C93.6972 83.2995 226.195 -173.985 544.772 -59.907",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-161.101 77.9159C96.008 88.8564 229.409 -169.172 547.886 -55.1396",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-159.247 82.8207C98.3188 94.4131 232.622 -164.359 551.001 -50.3724",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157.395 87.7253C100.629 99.9696 235.834 -159.546 554.114 -45.6053",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-155.541 92.6302C102.939 105.526 239.047 -154.733 557.229 -40.8379",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-153.688 97.5349C105.25 111.083 242.261 -149.92 560.344 -36.0707",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.835 102.44C107.56 116.64 245.473 -145.107 563.457 -31.3034",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.981 107.345C109.871 122.197 248.686 -140.293 566.572 -26.5361",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148.129 112.249C112.18 127.753 251.898 -135.48 569.685 -21.7689",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-146.275 117.154C114.491 133.31 255.112 -130.667 572.8 -17.0015",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.422 122.059C116.802 138.867 258.325 -125.854 575.914 -12.2342",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-142.569 126.964C119.112 144.423 261.537 -121.041 579.028 -7.46716",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140.716 131.868C121.423 149.98 264.75 -116.228 582.142 -2.69979",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-138.862 136.773C123.733 155.537 267.963 -111.415 585.257 2.06738",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.01 141.678C126.043 161.094 271.176 -106.602 588.37 6.83485",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-135.156 146.583C128.354 166.65 274.389 -101.789 591.485 11.6021",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133.304 151.488C130.664 172.207 277.601 -96.9756 594.599 16.3692",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-131.45 156.392C132.975 177.764 280.814 -92.1624 597.713 21.1365",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.597 161.297C135.285 183.32 284.027 -87.3494 600.828 25.9037",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.744 166.202C137.595 188.877 287.24 -82.5361 603.941 30.6711",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.891 171.107C139.906 194.434 290.453 -77.7231 607.056 35.4384",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124.038 176.012C142.216 199.991 293.665 -72.91 610.169 40.2057",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-122.185 180.916C144.526 205.547 296.878 -68.0968 613.284 44.973",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.331 185.821C146.837 211.104 300.092 -63.2838 616.398 49.7401",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.479 190.726C149.147 216.661 303.304 -58.4706 619.512 54.5075",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.625 195.631C151.458 222.218 306.517 -53.6576 622.626 59.2747",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-114.771 200.535C153.769 227.774 309.73 -48.8445 625.741 64.0419",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.919 205.44C156.078 233.331 312.943 -44.0314 628.854 68.8091",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.065 210.345C158.389 238.888 316.156 -39.2183 631.969 73.5764",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.213 215.25C160.699 244.444 319.368 -34.4052 635.083 78.3437",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.359 220.155C163.01 250.001 322.581 -29.592 638.197 83.1111",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.506 225.059C165.32 255.558 325.794 -24.779 641.312 87.8782",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.653 229.964C167.63 261.115 329.007 -19.9658 644.425 92.6456",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.8 234.869C169.941 266.671 332.22 -15.1528 647.54 97.4127",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.9463 239.774C172.252 272.228 335.433 -10.3395 650.654 102.18",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.0938 244.679C174.562 277.785 338.645 -5.52648 653.768 106.947",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.2402 249.583C176.872 283.341 341.859 -0.713434 656.882 111.715",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.3877 254.488C179.182 288.898 345.071 4.09967 659.996 116.482",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.5342 259.393C181.493 294.455 348.284 8.91278 663.11 121.249",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90.6807 264.298C183.804 300.012 351.497 13.7259 666.225 126.016",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88.8281 269.203C186.114 305.568 354.71 18.5391 669.338 130.784",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.9746 274.107C188.424 311.125 357.923 23.3522 672.453 135.551",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.1211 279.012C190.735 316.682 361.136 28.1654 675.567 140.318",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-83.2686 283.917C193.045 322.238 364.348 32.9783 678.681 145.085",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.415 288.822C195.356 327.795 367.561 37.7915 681.796 149.853",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.5625 293.727C197.665 333.352 370.774 42.6047 684.909 154.62",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.709 298.631C199.976 338.909 373.987 47.4176 688.024 159.387",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.8555 303.536C202.287 344.465 377.2 52.2308 691.138 164.155",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.0029 308.441C204.597 350.022 380.412 57.0438 694.252 168.922",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.1494 313.346C206.908 355.579 383.626 61.857 697.366 173.689",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.2969 318.251C209.217 361.136 386.838 66.6702 700.48 178.457",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.4434 323.155C211.528 366.692 390.051 71.4832 703.594 183.224",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.5898 328.06C213.839 372.249 393.264 76.2964 706.709 187.991",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.7373 332.965C216.149 377.806 396.477 81.1094 709.823 192.758",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.8838 337.87C218.46 383.362 399.69 85.9226 712.937 197.526",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.0303 342.774C220.77 388.919 402.903 90.7356 716.052 202.293",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.1777 347.679C223.08 394.476 406.115 95.5488 719.165 207.06",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.3242 352.584C225.391 400.032 409.328 100.362 722.28 211.827",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.4717 357.489C227.701 405.589 412.541 105.175 725.393 216.595",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.6182 362.394C230.011 411.146 415.754 109.988 728.508 221.362",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.7646 367.298C232.322 416.703 418.967 114.801 731.622 226.129",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.9121 372.203C234.632 422.259 422.179 119.614 734.736 230.896",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.0586 377.108C236.943 427.816 425.393 124.427 737.85 235.664",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.2051 382.013C239.254 433.373 428.606 129.241 740.965 240.431",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44.3525 386.917C241.563 438.929 431.818 134.053 744.078 245.198",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.499 391.822C243.874 444.486 435.031 138.867 747.193 249.965",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.6465 396.727C246.184 450.043 438.244 143.68 750.307 254.733",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.793 401.632C248.495 455.6 441.457 148.493 753.421 259.5",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.9395 406.537C250.806 461.157 444.67 153.306 756.536 264.267",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.0869 411.441C253.115 466.713 447.882 158.119 759.649 269.035",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.2334 416.346C255.426 472.27 451.095 162.932 762.764 273.802",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.3799 421.251C257.737 477.827 454.309 167.745 765.878 278.569",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.5273 426.156C260.047 483.383 457.521 172.558 768.992 283.336",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.6738 431.06C262.357 488.94 460.734 177.371 772.106 288.103",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.8213 435.965C264.667 494.497 463.946 182.185 775.22 292.871",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.9678 440.87C266.978 500.054 467.159 186.998 778.334 297.638",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.1143 445.775C269.289 505.61 470.373 191.811 781.449 302.405",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.2617 450.68C271.599 511.167 473.585 196.624 784.562 307.173",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.4082 455.584C273.909 516.724 476.798 201.437 787.677 311.94",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.5557 460.489C276.219 522.28 480.01 206.25 790.791 316.707",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.7021 465.394C278.53 527.837 483.224 211.063 793.905 321.474",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.8486 470.299C280.841 533.394 486.437 215.876 797.02 326.242",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.9961 475.203C283.151 538.95 489.649 220.689 800.133 331.009",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.14258 480.108C285.461 544.507 492.862 225.503 803.248 335.776",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.28906 485.013C287.772 550.064 496.076 230.316 806.362 340.544",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.43652 489.918C290.082 555.621 499.288 235.129 809.476 345.311",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.58301 494.823C292.393 561.177 502.501 239.942 812.59 350.078",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73047 499.727C294.702 566.734 505.713 244.755 815.704 354.845",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.123047 504.632C297.013 572.291 508.927 249.568 818.818 359.613",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97656 509.537C299.324 577.848 512.14 254.381 821.933 364.38",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8291 514.442C301.634 583.404 515.352 259.194 825.046 369.147",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68262 519.347C303.945 588.961 518.565 264.008 828.161 373.914",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53613 524.251C306.255 594.518 521.778 268.821 831.275 378.682",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38867 529.156C308.565 600.074 524.991 273.634 834.389 383.449",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 534.061C310.876 605.631 528.204 278.447 837.504 388.216",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0947 538.966C313.186 611.188 531.416 283.26 840.617 392.983",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9482 543.871C315.496 616.745 534.629 288.073 843.732 397.751",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8018 548.775C317.807 622.301 537.843 292.886 846.846 402.518",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 553.68C320.117 627.858 541.055 297.699 849.96 407.285",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5078 558.585C322.428 633.415 544.268 302.512 853.074 412.053",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3613 563.49C324.739 638.971 547.481 307.325 856.189 416.82",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2139 568.395C327.048 644.528 550.693 312.139 859.302 421.587",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0674 573.299C329.359 650.085 553.907 316.952 862.417 426.354",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9199 578.204C331.669 655.642 557.119 321.765 865.53 431.122",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7734 583.109C333.98 661.198 560.332 326.578 868.645 435.889",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.627 588.014C336.291 666.755 563.545 331.391 871.76 440.656",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4795 592.918C338.6 672.312 566.758 336.204 874.873 445.423",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.333 597.823C340.911 677.869 569.971 341.017 877.988 450.191",
    stroke: "#D4D4D4",
    strokeWidth: 0.93914,
    strokeMiterlimit: 10
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0V236.522L562.07 232.512C456 107 266 51.0001 147 26.0001C74 10.6639 0 2 0 2V0H565.22Z",
    fill: "url(#paint1_linear_1375_1010)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317965V228.042C400.61 18.1718 3 2.53174 0 0.0317383L565.22 0.0317965Z",
    fill: "url(#paint2_radial_1375_1010)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.305 399.692H0V251.094C80.7595 337.208 186.225 380.37 289.305 399.692Z",
    fill: "url(#paint3_linear_1375_1010)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.231 399.692H0V281.437C64.2691 349.966 148.199 384.315 230.231 399.692Z",
    fill: "url(#paint4_linear_1375_1010)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.87 399.692H0V294.463C57.1894 355.444 131.874 386.009 204.87 399.692Z",
    fill: "url(#paint5_linear_1375_1010)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.277 399.692H0V295.795C56.4655 356.004 130.205 386.182 202.277 399.692Z",
    fill: "url(#paint6_linear_1375_1010)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0316591V179.122C392.13 17.2017 0 0.0314941 0 0.0314941L565.22 0.0316591Z",
    fill: "url(#paint7_radial_1375_1010)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M555 0.0317993V172.032C385.04 16.5221 0 0.0317383 0 0.0317383L555 0.0317993Z",
    fill: "url(#paint8_radial_1375_1010)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317126V155.732C392.13 -6.18829 0 0.0316272 0 0.0316272L565.22 0.0317126Z",
    fill: "url(#paint9_radial_1375_1010)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383V134.804C475.257 50.6466 359.766 13.4468 251.61 0.0317383H565.22Z",
    fill: "url(#paint10_radial_1375_1010)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383V132.342C476.9 49.7217 363.52 13.2017 257.34 0.0317383H565.22Z",
    fill: "url(#paint11_radial_1375_1010)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383V108.952C507.82 55.2617 439.84 21.0317 370.13 0.0317383H565.22Z",
    fill: "url(#paint12_radial_1375_1010)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M565.22 0.0317383V106.695C509.01 54.1173 442.438 20.5965 374.173 0.0317383H565.22Z",
    fill: "url(#paint13_radial_1375_1010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M467.675 201.607C504.521 201.607 534.39 171.738 534.39 134.892C534.39 98.0464 504.521 68.177 467.675 68.177C430.829 68.177 400.96 98.0464 400.96 134.892C400.96 171.738 430.829 201.607 467.675 201.607Z",
    fill: "url(#paint14_radial_1375_1010)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M456.604 269.92C493.45 269.92 523.319 240.05 523.319 203.205C523.319 166.359 493.45 136.49 456.604 136.49C419.758 136.49 389.889 166.359 389.889 203.205C389.889 240.05 419.758 269.92 456.604 269.92Z",
    fill: "url(#paint15_radial_1375_1010)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M522.276 118.447C528.767 82.1777 504.626 47.5136 468.357 41.0228C432.087 34.5321 397.423 58.6727 390.932 94.9423C384.441 131.212 408.582 165.876 444.852 172.367C481.121 178.858 515.785 154.717 522.276 118.447Z",
    fill: "url(#paint16_radial_1375_1010)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M444.664 164.67H412.708V241.487L444.664 217.411L476.62 241.487V164.67H444.664Z",
    fill: "url(#paint17_linear_1375_1010)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M444.664 164.67H413.906V238.608L444.664 215.434L475.423 238.608V164.67H444.664Z",
    fill: "url(#paint18_linear_1375_1010)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.664 164.67H424.478V213.195L444.664 197.986L464.851 213.195V164.67H444.664Z",
    fill: "url(#paint19_linear_1375_1010)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M444.664 164.67H425.448V210.862L444.664 196.384L463.88 210.862V164.67H444.664Z",
    fill: "url(#paint20_linear_1375_1010)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M444.775 179.874C475.027 179.874 499.55 155.35 499.55 125.099C499.55 94.8472 475.027 70.3235 444.775 70.3235C414.524 70.3235 390 94.8472 390 125.099C390 155.35 414.524 179.874 444.775 179.874Z",
    fill: "url(#paint21_linear_1375_1010)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M444.664 172.325C470.746 172.325 491.891 151.181 491.891 125.099C491.891 99.0161 470.746 77.8721 444.664 77.8721C418.582 77.8721 397.438 99.0161 397.438 125.099C397.438 151.181 418.582 172.325 444.664 172.325Z",
    fill: "url(#paint22_linear_1375_1010)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M451.583 169.686C476.05 165.865 492.787 142.933 488.967 118.466C485.146 93.9982 462.214 77.2609 437.746 81.0818C413.279 84.9026 396.542 107.835 400.363 132.302C404.183 156.769 427.115 173.507 451.583 169.686Z",
    fill: "url(#paint23_linear_1375_1010)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M464.026 145.018H423.94V145.709H464.026V145.018Z",
    fill: "#102F49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M464.026 107.525H423.94V108.216H464.026V107.525Z",
    fill: "#102F49"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M443.983 93.3608L445.285 95.9988L448.197 96.4218L446.09 98.4758L446.587 101.376L443.983 100.006L441.379 101.376L441.876 98.4758L439.769 96.4218L442.681 95.9988L443.983 93.3608Z",
    fill: "url(#paint24_linear_1375_1010)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M443.983 151.859L445.285 154.497L448.197 154.92L446.09 156.974L446.587 159.874L443.983 158.505L441.379 159.874L441.876 156.974L439.769 154.92L442.681 154.497L443.983 151.859Z",
    fill: "url(#paint25_linear_1375_1010)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9961 102.459L45.835 102.737C44.9561 104.271 44.1943 105.804 43.5498 107.337L43.418 107.674L43.2275 107.571C43.0029 106.087 42.4805 104.91 41.6602 104.041C40.8398 103.172 39.8486 102.737 38.6865 102.737C37.4463 102.737 36.4111 103.279 35.5811 104.363C34.5361 105.711 34.0137 107.996 34.0137 111.219C34.0137 113.992 34.4922 116.165 35.4492 117.737C36.416 119.31 37.7539 120.096 39.4629 120.096C40.8301 120.096 41.9189 119.642 42.7295 118.733C43.5498 117.815 44.0381 116.507 44.1943 114.808C44.2334 114.397 44.3994 114.192 44.6924 114.192C45.0732 114.192 45.2637 114.51 45.2637 115.145C45.2637 116.092 45.0488 117.073 44.6191 118.089C43.7109 120.237 41.8359 121.312 38.9941 121.312C36.4551 121.312 34.4385 120.423 32.9443 118.646C31.4502 116.858 30.7031 114.446 30.7031 111.409C30.7031 108.606 31.4795 106.258 33.0322 104.363C34.585 102.469 36.5137 101.521 38.8184 101.521C39.9121 101.521 41.1572 101.79 42.5537 102.327C43.2861 102.61 43.8916 102.752 44.3701 102.752C44.8877 102.752 45.3516 102.61 45.7617 102.327L45.9961 102.459ZM41.748 104.993C40.8594 104.28 40.0195 103.924 39.2285 103.924C36.6992 103.924 35.4346 106.336 35.4346 111.16C35.4346 113.357 35.7275 115.188 36.3135 116.653C36.8994 118.108 37.7246 119.051 38.7891 119.48V119.627C37.6367 119.393 36.7139 118.509 36.0205 116.976C35.3369 115.433 34.9951 113.484 34.9951 111.131C34.9951 106.082 36.3818 103.558 39.1553 103.558C40.0928 103.558 40.957 103.973 41.748 104.803V104.993ZM46.5234 115.057C46.3672 117.479 45.6885 119.324 44.4873 120.594C43.2959 121.854 41.626 122.483 39.4775 122.483C37.8467 122.483 36.3281 121.98 34.9219 120.975V120.857C36.1719 121.678 37.6807 122.088 39.4482 122.088C41.3818 122.088 42.959 121.468 44.1797 120.228C44.7754 119.622 45.2148 118.943 45.498 118.191C45.7812 117.439 45.9717 116.443 46.0693 115.203L46.0986 114.866L46.5234 115.057ZM47.0654 103.162L46.9043 103.44C45.8398 105.257 44.9902 106.912 44.3555 108.406L43.96 108.216L44.1211 107.85C44.6094 106.824 45.0391 105.975 45.4102 105.301L46.582 103.221L46.7285 102.957L47.0654 103.162ZM63.9404 102.005L63.7061 102.283C62.71 103.504 61.9189 104.905 61.333 106.487C61.2354 106.263 61.1621 106.097 61.1133 105.989C60.5762 104.817 60 104.061 59.3848 103.719C58.7695 103.377 57.666 103.206 56.0742 103.206C55.3418 103.206 54.4629 103.23 53.4375 103.279V110.018H54.375V104.056C55.1172 103.987 55.8252 103.953 56.499 103.953C57.7393 103.953 58.6523 104.085 59.2383 104.349C59.8242 104.612 60.3467 105.125 60.8057 105.887C60.6689 105.789 60.5713 105.716 60.5127 105.667C59.7217 105.042 59.1504 104.671 58.7988 104.554C58.4473 104.437 57.7539 104.378 56.7188 104.378C56.4062 104.378 55.8496 104.397 55.0488 104.437L54.7412 104.451V110.018H57.4365L59.3262 107.425V113.738L57.4365 111.292H53.4375V119.51H54.375V111.98H57.5537L57.9346 112.361H54.7412V119.51C56.7334 119.51 58.1494 119.368 58.9893 119.085C59.8291 118.802 60.4883 118.245 60.9668 117.415L61.7432 116.082C61.7725 116.023 61.8311 115.916 61.9189 115.76C62.1729 116.834 62.4854 117.693 62.8564 118.338C63.2373 118.982 63.8623 119.734 64.7314 120.594H48.3105L50.5371 118.895V112.361C49.7168 112.459 48.9746 112.713 48.3105 113.123L48.1055 112.815C48.7012 112.386 49.5117 112.107 50.5371 111.98V111.292C50.3711 111.272 50.2539 111.263 50.1855 111.263C49.1895 111.263 48.2812 111.629 47.4609 112.361C47.9102 110.799 48.9355 110.018 50.5371 110.018V103.763L48.3105 102.005H63.9404ZM64.6436 103.03L64.541 103.162C63.3496 104.764 62.5537 106.106 62.1533 107.19L61.9043 106.883C62.5586 105.369 63.4033 103.982 64.4385 102.723L64.6436 103.03ZM60.3369 107.908V114.383L59.9707 114.192V107.718L60.3369 107.908ZM66.4014 120.682L65.6396 122H49.6436L49.4092 121.604H65.4492L65.9473 120.682C64.541 119.383 63.5498 117.996 62.9736 116.521L63.4424 116.697C63.9795 117.947 64.8877 119.197 66.167 120.447L66.4014 120.682ZM67.4121 103.763C69.7266 102.425 72.2168 101.756 74.8828 101.756C76.9531 101.756 78.6572 102.205 79.9951 103.104C81.3428 104.002 82.0166 105.145 82.0166 106.531C82.0166 107.664 81.5771 108.67 80.6982 109.549C79.8193 110.418 78.6182 111.048 77.0947 111.438C77.7686 113.294 78.6816 115.101 79.834 116.858C80.9961 118.616 82.1582 119.964 83.3203 120.901L83.1006 120.975C81.6455 121.473 80.2197 122.176 78.8232 123.084L78.6035 123.23L78.5303 122.762C77.9053 118.982 77.0312 115.779 75.9082 113.152L75.8496 113.006C75.1758 113.318 74.2725 113.567 73.1396 113.753L73.0225 113.768V119.246L75.6006 122H68.0273L67.793 121.604H74.7656L72.6416 119.349V113.445L72.9492 113.401C74.0625 113.284 74.9951 113.064 75.7471 112.742C75.6885 112.625 75.6543 112.552 75.6445 112.522L75.498 112.098C75.4883 112.068 75.4639 112.01 75.4248 111.922C74.8193 112.098 73.6768 112.288 71.9971 112.493L71.8359 112.522V119.056L73.5059 120.799H67.0312L68.9355 119.056V114.134L68.8184 114.148C68.252 114.275 67.7393 114.417 67.2803 114.573L67.1631 114.617L67.0312 114.324C67.4609 114.158 67.7979 114.046 68.042 113.987L68.8184 113.797L68.9355 113.768V113.006C68.3594 113.006 67.6416 113.133 66.7822 113.387L66.6211 113.445C66.6406 113.309 66.7383 112.991 66.9141 112.493C66.9336 112.454 67.002 112.234 67.1191 111.834C67.1289 111.805 67.1436 111.761 67.1631 111.702C67.6025 111.731 67.9443 111.746 68.1885 111.746C68.4521 111.746 68.6963 111.731 68.9209 111.702V104.495C68.4717 104.222 68.0078 103.992 67.5293 103.807L67.4121 103.763ZM71.8359 103.382V111.277C72.1191 111.277 72.3877 111.253 72.6416 111.204V103.997C73.1787 103.851 73.8232 103.777 74.5752 103.777C76.4795 103.777 77.7734 104.402 78.457 105.652C77.7344 105.066 77.0996 104.666 76.5527 104.451C76.0059 104.227 75.3516 104.114 74.5898 104.114C73.9941 104.114 73.4717 104.173 73.0225 104.29V111.204L73.1836 111.175C75.1074 110.823 76.5332 110.271 77.4609 109.52C78.3984 108.758 78.8672 107.771 78.8672 106.561C78.8672 105.477 78.4473 104.583 77.6074 103.88C76.7676 103.167 75.708 102.811 74.4287 102.811C73.4033 102.811 72.5391 103.001 71.8359 103.382ZM78.9111 112.171C79.5264 114.183 80.6152 116.15 82.1777 118.074C83.1543 119.275 84.3896 120.354 85.8838 121.312C83.6475 121.907 81.5479 122.815 79.585 124.036L79.4531 124.124L79.1602 123.89C81.0254 122.669 83.0127 121.771 85.1221 121.194C82.3096 119.319 80.0977 116.321 78.4863 112.2L78.3984 111.951C81.3867 110.818 82.8809 109.09 82.8809 106.766C82.8809 105.809 82.4951 104.764 81.7236 103.631C82.71 104.529 83.2031 105.672 83.2031 107.059C83.2031 109.305 81.7725 111.009 78.9111 112.171ZM102.129 102.005C102.041 102.171 101.982 102.283 101.953 102.342L100.957 104.1C100.615 104.725 100.298 105.506 100.005 106.443L99.9756 106.517L99.8291 106.414L99.7852 106.224C99.502 105.11 99.0967 104.339 98.5693 103.909C98.0518 103.479 97.2559 103.265 96.1816 103.265C95.7422 103.265 95.3027 103.284 94.8633 103.323H94.6875V119.202L96.416 120.799H89.7217L91.7725 119.085V104.51L90.7324 104.495C89.7266 104.495 89.0088 104.695 88.5791 105.096C88.1592 105.486 87.9102 106.18 87.832 107.176H87.4512C87.5586 106.033 87.8516 105.237 88.3301 104.788C88.8184 104.339 89.6191 104.114 90.7324 104.114L91.6113 104.129H91.7725V103.411C91.2744 103.353 90.8008 103.323 90.3516 103.323C89.0918 103.323 88.1836 103.582 87.627 104.1C87.0703 104.607 86.7627 105.472 86.7041 106.692H86.5283C86.1084 105.335 85.459 103.821 84.5801 102.151L84.4922 102.005H102.129ZM103.052 102.928C102.378 103.787 101.67 105.213 100.928 107.205L100.869 107.352L100.547 107.073L100.591 106.941C101.313 104.92 102.012 103.514 102.686 102.723L102.759 102.635L103.052 102.928ZM99.1406 105.213C98.3887 104.725 97.5098 104.48 96.5039 104.48C96.2793 104.48 96.0449 104.495 95.8008 104.524L95.8594 119.246L98.1885 122H90.7031L90.3662 121.604H97.3828L95.4199 119.363V104.1L96.2109 104.085C97.1582 104.085 97.8271 104.163 98.2178 104.319C98.6182 104.466 98.9258 104.764 99.1406 105.213ZM103.169 102.005H110.112L108.149 103.997V119.246L109.995 120.799H103.169L105.205 119.114V103.836L103.169 102.005ZM110.771 102.84L109.277 104.319V119.246L111.738 122H104.121L103.755 121.604H110.874L108.867 119.393V104.188L110.522 102.547L110.771 102.84ZM112.661 102.005H127.866C127.261 102.806 126.826 103.436 126.562 103.895C126.309 104.354 125.981 105.091 125.581 106.106L125.464 106.399C124.819 105.071 124.18 104.212 123.545 103.821C122.92 103.431 121.86 103.235 120.366 103.235L119.531 103.25L118.11 103.235L117.568 103.221V110.076H118.462V104.026L118.887 104.012C119.492 103.982 120.137 103.968 120.82 103.968C122.812 103.968 124.058 104.485 124.556 105.521C124.077 105.062 123.555 104.754 122.988 104.598C122.432 104.432 121.567 104.349 120.396 104.349C119.976 104.349 119.453 104.373 118.828 104.422V110.076H121.04L123.384 107.601V113.738L120.923 111.307H117.568V118.689L119.443 120.594H112.251L114.639 118.689V112.391C113.887 112.391 113.228 112.674 112.661 113.24L112.383 112.933C112.949 112.308 113.701 111.995 114.639 111.995V111.307C114.434 111.287 114.287 111.277 114.199 111.277C113.291 111.277 112.505 111.648 111.841 112.391L111.738 112.156C112.178 110.887 113.145 110.193 114.639 110.076V103.895L112.661 102.005ZM128.979 102.898C127.583 104.529 126.704 106.023 126.343 107.381L126.035 107.176C126.406 105.643 127.3 104.134 128.716 102.649L128.979 102.898ZM124.453 108.113V114.441L124.072 114.222V107.894L124.453 108.113ZM121.831 112.537H118.828V118.807L121.406 122H112.925L112.559 121.604H120.586L118.462 118.982V112.142H121.406L121.831 112.537ZM128.892 102.005H135.835L133.872 103.997V119.246L135.718 120.799H128.892L130.928 119.114V103.836L128.892 102.005ZM136.494 102.84L135 104.319V119.246L137.461 122H129.844L129.478 121.604H136.597L134.59 119.393V104.188L136.245 102.547L136.494 102.84ZM153.457 102.459L153.296 102.737C152.417 104.271 151.655 105.804 151.011 107.337L150.879 107.674L150.688 107.571C150.464 106.087 149.941 104.91 149.121 104.041C148.301 103.172 147.31 102.737 146.147 102.737C144.907 102.737 143.872 103.279 143.042 104.363C141.997 105.711 141.475 107.996 141.475 111.219C141.475 113.992 141.953 116.165 142.91 117.737C143.877 119.31 145.215 120.096 146.924 120.096C148.291 120.096 149.38 119.642 150.19 118.733C151.011 117.815 151.499 116.507 151.655 114.808C151.694 114.397 151.86 114.192 152.153 114.192C152.534 114.192 152.725 114.51 152.725 115.145C152.725 116.092 152.51 117.073 152.08 118.089C151.172 120.237 149.297 121.312 146.455 121.312C143.916 121.312 141.899 120.423 140.405 118.646C138.911 116.858 138.164 114.446 138.164 111.409C138.164 108.606 138.94 106.258 140.493 104.363C142.046 102.469 143.975 101.521 146.279 101.521C147.373 101.521 148.618 101.79 150.015 102.327C150.747 102.61 151.353 102.752 151.831 102.752C152.349 102.752 152.812 102.61 153.223 102.327L153.457 102.459ZM149.209 104.993C148.32 104.28 147.48 103.924 146.689 103.924C144.16 103.924 142.896 106.336 142.896 111.16C142.896 113.357 143.188 115.188 143.774 116.653C144.36 118.108 145.186 119.051 146.25 119.48V119.627C145.098 119.393 144.175 118.509 143.481 116.976C142.798 115.433 142.456 113.484 142.456 111.131C142.456 106.082 143.843 103.558 146.616 103.558C147.554 103.558 148.418 103.973 149.209 104.803V104.993ZM153.984 115.057C153.828 117.479 153.149 119.324 151.948 120.594C150.757 121.854 149.087 122.483 146.938 122.483C145.308 122.483 143.789 121.98 142.383 120.975V120.857C143.633 121.678 145.142 122.088 146.909 122.088C148.843 122.088 150.42 121.468 151.641 120.228C152.236 119.622 152.676 118.943 152.959 118.191C153.242 117.439 153.433 116.443 153.53 115.203L153.56 114.866L153.984 115.057ZM154.526 103.162L154.365 103.44C153.301 105.257 152.451 106.912 151.816 108.406L151.421 108.216L151.582 107.85C152.07 106.824 152.5 105.975 152.871 105.301L154.043 103.221L154.189 102.957L154.526 103.162ZM169.087 102.005L167.563 103.733L169.966 110.12L170.552 109.798L168.384 104.026L169.937 102.239L170.317 102.4L168.838 104.114L170.889 109.578C171.006 109.49 171.074 109.437 171.094 109.417L171.577 109.007C171.87 108.772 172.056 108.606 172.134 108.509C172.388 109.622 172.778 110.618 173.306 111.497C173.022 111.478 172.817 111.468 172.69 111.468C171.763 111.468 171.084 111.614 170.654 111.907L173.306 119.1L175.503 120.799H168.105L170.127 119.1L168.501 114.822C167.427 115.906 166.602 116.937 166.025 117.913L165.688 117.825C166.265 116.868 167.124 115.799 168.267 114.617L168.384 114.471L168.105 113.826C166.943 114.793 165.981 115.916 165.22 117.195L164.956 116.771C164.448 115.96 163.799 115.037 163.008 114.002L162.861 113.826C162.109 115.496 161.733 116.854 161.733 117.898C161.733 118.514 161.836 119.036 162.041 119.466C162.256 119.886 162.764 120.594 163.564 121.59C163.633 121.678 163.74 121.814 163.887 122H155.977L155.684 121.604H163.14L162.891 121.297C162.246 120.516 161.821 119.91 161.616 119.48C161.421 119.041 161.323 118.528 161.323 117.942C161.323 116.946 161.729 115.462 162.539 113.489L161.895 112.815C161.768 113.128 161.606 113.587 161.411 114.192L160.928 115.687C160.664 116.487 160.532 117.151 160.532 117.679C160.532 118.226 160.625 118.68 160.811 119.041C160.996 119.402 161.387 119.896 161.982 120.521C162.041 120.579 162.129 120.672 162.246 120.799H154.922C156.318 120.076 157.422 119.104 158.232 117.884C159.053 116.663 159.863 114.778 160.664 112.229L160.723 112.024C160.205 111.585 159.458 111.316 158.481 111.219C159.019 110.418 159.434 109.583 159.727 108.714C159.863 108.841 159.946 108.919 159.976 108.948L160.635 109.563C160.859 109.778 161.128 109.998 161.44 110.223L161.704 109.578L161.528 109.432C161.04 109.002 160.63 108.655 160.298 108.392L160.166 108.289L160.4 107.967C160.918 108.309 161.416 108.704 161.895 109.153L163.887 103.675L162.334 102.005H169.087ZM165.469 106.707L163.857 110.955C163.945 111.053 163.994 111.111 164.004 111.131L164.604 111.805C164.927 112.156 165.337 112.703 165.835 113.445L165.981 113.665C166.401 113.138 166.899 112.615 167.476 112.098L165.469 106.707ZM164.81 105.008L162.48 111.16C163.223 111.922 163.862 112.674 164.399 113.416L165.073 114.354C165.083 114.363 165.132 114.427 165.22 114.544C165.308 114.456 165.356 114.402 165.366 114.383L165.571 114.134C165.601 114.095 165.654 114.031 165.732 113.943C165.049 112.889 164.253 111.937 163.345 111.087L165.22 106.136L164.81 105.008ZM173.423 109.212C173.638 110.091 174.175 111.297 175.034 112.83C174.819 112.801 174.697 112.786 174.668 112.786L173.481 112.684C172.944 112.635 172.554 112.61 172.31 112.61C172.271 112.61 172.173 112.615 172.017 112.625L174.463 119.114L177.729 122H169.248L168.97 121.604H176.748L174.111 119.275L171.504 112.376C171.836 112.288 172.217 112.244 172.646 112.244C173.174 112.244 173.76 112.288 174.404 112.376L174.229 112.054C173.604 110.901 173.184 109.861 172.969 108.934L173.423 109.212ZM194.561 102.005C194.473 102.171 194.414 102.283 194.385 102.342L193.389 104.1C193.047 104.725 192.729 105.506 192.437 106.443L192.407 106.517L192.261 106.414L192.217 106.224C191.934 105.11 191.528 104.339 191.001 103.909C190.483 103.479 189.688 103.265 188.613 103.265C188.174 103.265 187.734 103.284 187.295 103.323H187.119V119.202L188.848 120.799H182.153L184.204 119.085V104.51L183.164 104.495C182.158 104.495 181.44 104.695 181.011 105.096C180.591 105.486 180.342 106.18 180.264 107.176H179.883C179.99 106.033 180.283 105.237 180.762 104.788C181.25 104.339 182.051 104.114 183.164 104.114L184.043 104.129H184.204V103.411C183.706 103.353 183.232 103.323 182.783 103.323C181.523 103.323 180.615 103.582 180.059 104.1C179.502 104.607 179.194 105.472 179.136 106.692H178.96C178.54 105.335 177.891 103.821 177.012 102.151L176.924 102.005H194.561ZM195.483 102.928C194.81 103.787 194.102 105.213 193.359 107.205L193.301 107.352L192.979 107.073L193.022 106.941C193.745 104.92 194.443 103.514 195.117 102.723L195.19 102.635L195.483 102.928ZM191.572 105.213C190.82 104.725 189.941 104.48 188.936 104.48C188.711 104.48 188.477 104.495 188.232 104.524L188.291 119.246L190.62 122H183.135L182.798 121.604H189.814L187.852 119.363V104.1L188.643 104.085C189.59 104.085 190.259 104.163 190.649 104.319C191.05 104.466 191.357 104.764 191.572 105.213ZM211.479 102.005L211.245 102.283C210.249 103.504 209.458 104.905 208.872 106.487C208.774 106.263 208.701 106.097 208.652 105.989C208.115 104.817 207.539 104.061 206.924 103.719C206.309 103.377 205.205 103.206 203.613 103.206C202.881 103.206 202.002 103.23 200.977 103.279V110.018H201.914V104.056C202.656 103.987 203.364 103.953 204.038 103.953C205.278 103.953 206.191 104.085 206.777 104.349C207.363 104.612 207.886 105.125 208.345 105.887C208.208 105.789 208.11 105.716 208.052 105.667C207.261 105.042 206.689 104.671 206.338 104.554C205.986 104.437 205.293 104.378 204.258 104.378C203.945 104.378 203.389 104.397 202.588 104.437L202.28 104.451V110.018H204.976L206.865 107.425V113.738L204.976 111.292H200.977V119.51H201.914V111.98H205.093L205.474 112.361H202.28V119.51C204.272 119.51 205.688 119.368 206.528 119.085C207.368 118.802 208.027 118.245 208.506 117.415L209.282 116.082C209.312 116.023 209.37 115.916 209.458 115.76C209.712 116.834 210.024 117.693 210.396 118.338C210.776 118.982 211.401 119.734 212.271 120.594H195.85L198.076 118.895V112.361C197.256 112.459 196.514 112.713 195.85 113.123L195.645 112.815C196.24 112.386 197.051 112.107 198.076 111.98V111.292C197.91 111.272 197.793 111.263 197.725 111.263C196.729 111.263 195.82 111.629 195 112.361C195.449 110.799 196.475 110.018 198.076 110.018V103.763L195.85 102.005H211.479ZM212.183 103.03L212.08 103.162C210.889 104.764 210.093 106.106 209.692 107.19L209.443 106.883C210.098 105.369 210.942 103.982 211.978 102.723L212.183 103.03ZM207.876 107.908V114.383L207.51 114.192V107.718L207.876 107.908ZM213.94 120.682L213.179 122H197.183L196.948 121.604H212.988L213.486 120.682C212.08 119.383 211.089 117.996 210.513 116.521L210.981 116.697C211.519 117.947 212.427 119.197 213.706 120.447L213.94 120.682Z",
    fill: "url(#paint26_linear_1375_1010)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 139.078L36.2422 139C35.7422 138.724 35.2839 138.586 34.8672 138.586C33.4974 138.586 32.8125 139.932 32.8125 142.625C32.8125 144.594 33.237 145.898 34.0859 146.539L34.0156 146.617C33.4948 146.247 33.1224 145.763 32.8984 145.164C32.6797 144.56 32.5703 143.745 32.5703 142.719C32.5703 139.828 33.3307 138.383 34.8516 138.383C35.5443 138.383 36.0521 138.615 36.375 139.078ZM34.7031 137.234C35.9688 137.234 36.9792 137.714 37.7344 138.672C38.4948 139.63 38.875 140.911 38.875 142.516C38.875 144.031 38.5 145.24 37.75 146.141C37.0052 147.042 36.0026 147.492 34.7422 147.492C33.7474 147.492 32.862 147.174 32.0859 146.539C30.9453 145.602 30.375 144.214 30.375 142.375C30.375 140.802 30.7656 139.552 31.5469 138.625C32.3281 137.698 33.3802 137.234 34.7031 137.234ZM34.7031 137.906C32.9427 137.906 32.0625 139.453 32.0625 142.547C32.0625 145.406 32.9297 146.836 34.6641 146.836C35.4714 146.836 36.0859 146.458 36.5078 145.703C36.9297 144.943 37.1406 143.833 37.1406 142.375C37.1406 140.724 36.9375 139.573 36.5312 138.922C36.1042 138.245 35.4948 137.906 34.7031 137.906ZM37.1953 137.633C37.9401 137.992 38.5286 138.607 38.9609 139.477C39.3932 140.346 39.6094 141.352 39.6094 142.492C39.6094 144.169 39.1823 145.523 38.3281 146.555C37.4792 147.586 36.362 148.102 34.9766 148.102C34.0911 148.102 33.263 147.802 32.4922 147.203V147.164C33.138 147.638 33.9479 147.875 34.9219 147.875C36.2292 147.875 37.3021 147.383 38.1406 146.398C38.9792 145.414 39.3984 144.156 39.3984 142.625C39.3984 141.484 39.2057 140.487 38.8203 139.633C38.4401 138.779 37.8984 138.141 37.1953 137.719V137.633ZM40.4766 137.336H48.5859C48.263 137.763 48.0312 138.099 47.8906 138.344C47.7552 138.589 47.5807 138.982 47.3672 139.523L47.3047 139.68C46.9609 138.971 46.6198 138.513 46.2812 138.305C45.9479 138.096 45.3828 137.992 44.5859 137.992L44.1406 138L43.3828 137.992L43.0938 137.984V141.641H43.5703V138.414L43.7969 138.406C44.1198 138.391 44.4635 138.383 44.8281 138.383C45.8906 138.383 46.5547 138.659 46.8203 139.211C46.5651 138.966 46.2865 138.802 45.9844 138.719C45.6875 138.63 45.2266 138.586 44.6016 138.586C44.3776 138.586 44.099 138.599 43.7656 138.625V141.641H44.9453L46.1953 140.32V143.594L44.8828 142.297H43.0938V146.234L44.0938 147.25H40.2578L41.5312 146.234V142.875C41.1302 142.875 40.7786 143.026 40.4766 143.328L40.3281 143.164C40.6302 142.831 41.0312 142.664 41.5312 142.664V142.297C41.4219 142.286 41.3438 142.281 41.2969 142.281C40.8125 142.281 40.3932 142.479 40.0391 142.875L39.9844 142.75C40.2188 142.073 40.7344 141.703 41.5312 141.641V138.344L40.4766 137.336ZM49.1797 137.812C48.4349 138.682 47.9661 139.479 47.7734 140.203L47.6094 140.094C47.8073 139.276 48.2839 138.471 49.0391 137.68L49.1797 137.812ZM46.7656 140.594V143.969L46.5625 143.852V140.477L46.7656 140.594ZM45.3672 142.953H43.7656V146.297L45.1406 148H40.6172L40.4219 147.789H44.7031L43.5703 146.391V142.742H45.1406L45.3672 142.953ZM61.3438 137.578L61.2578 137.727C60.7891 138.544 60.3828 139.362 60.0391 140.18L59.9688 140.359L59.8672 140.305C59.7474 139.513 59.4688 138.885 59.0312 138.422C58.5938 137.958 58.0651 137.727 57.4453 137.727C56.7839 137.727 56.2318 138.016 55.7891 138.594C55.2318 139.312 54.9531 140.531 54.9531 142.25C54.9531 143.729 55.2083 144.888 55.7188 145.727C56.2344 146.565 56.9479 146.984 57.8594 146.984C58.5885 146.984 59.1693 146.742 59.6016 146.258C60.0391 145.768 60.2995 145.07 60.3828 144.164C60.4036 143.945 60.4922 143.836 60.6484 143.836C60.8516 143.836 60.9531 144.005 60.9531 144.344C60.9531 144.849 60.8385 145.372 60.6094 145.914C60.125 147.06 59.125 147.633 57.6094 147.633C56.2552 147.633 55.1797 147.159 54.3828 146.211C53.5859 145.258 53.1875 143.971 53.1875 142.352C53.1875 140.857 53.6016 139.604 54.4297 138.594C55.2578 137.583 56.2865 137.078 57.5156 137.078C58.099 137.078 58.763 137.221 59.5078 137.508C59.8984 137.659 60.2214 137.734 60.4766 137.734C60.7526 137.734 61 137.659 61.2188 137.508L61.3438 137.578ZM59.0781 138.93C58.6042 138.549 58.1562 138.359 57.7344 138.359C56.3854 138.359 55.7109 139.646 55.7109 142.219C55.7109 143.391 55.8672 144.367 56.1797 145.148C56.4922 145.924 56.9323 146.427 57.5 146.656V146.734C56.8854 146.609 56.3932 146.138 56.0234 145.32C55.6589 144.497 55.4766 143.458 55.4766 142.203C55.4766 139.51 56.2161 138.164 57.6953 138.164C58.1953 138.164 58.6562 138.385 59.0781 138.828V138.93ZM61.625 144.297C61.5417 145.589 61.1797 146.573 60.5391 147.25C59.9036 147.922 59.013 148.258 57.8672 148.258C56.9974 148.258 56.1875 147.99 55.4375 147.453V147.391C56.1042 147.828 56.9089 148.047 57.8516 148.047C58.8828 148.047 59.724 147.716 60.375 147.055C60.6927 146.732 60.9271 146.37 61.0781 145.969C61.2292 145.568 61.3307 145.036 61.3828 144.375L61.3984 144.195L61.625 144.297ZM61.9141 137.953L61.8281 138.102C61.2604 139.07 60.8073 139.953 60.4688 140.75L60.2578 140.648L60.3438 140.453C60.6042 139.906 60.8333 139.453 61.0312 139.094L61.6562 137.984L61.7344 137.844L61.9141 137.953ZM68.5 139.078L68.3672 139C67.8672 138.724 67.4089 138.586 66.9922 138.586C65.6224 138.586 64.9375 139.932 64.9375 142.625C64.9375 144.594 65.362 145.898 66.2109 146.539L66.1406 146.617C65.6198 146.247 65.2474 145.763 65.0234 145.164C64.8047 144.56 64.6953 143.745 64.6953 142.719C64.6953 139.828 65.4557 138.383 66.9766 138.383C67.6693 138.383 68.1771 138.615 68.5 139.078ZM66.8281 137.234C68.0938 137.234 69.1042 137.714 69.8594 138.672C70.6198 139.63 71 140.911 71 142.516C71 144.031 70.625 145.24 69.875 146.141C69.1302 147.042 68.1276 147.492 66.8672 147.492C65.8724 147.492 64.987 147.174 64.2109 146.539C63.0703 145.602 62.5 144.214 62.5 142.375C62.5 140.802 62.8906 139.552 63.6719 138.625C64.4531 137.698 65.5052 137.234 66.8281 137.234ZM66.8281 137.906C65.0677 137.906 64.1875 139.453 64.1875 142.547C64.1875 145.406 65.0547 146.836 66.7891 146.836C67.5964 146.836 68.2109 146.458 68.6328 145.703C69.0547 144.943 69.2656 143.833 69.2656 142.375C69.2656 140.724 69.0625 139.573 68.6562 138.922C68.2292 138.245 67.6198 137.906 66.8281 137.906ZM69.3203 137.633C70.0651 137.992 70.6536 138.607 71.0859 139.477C71.5182 140.346 71.7344 141.352 71.7344 142.492C71.7344 144.169 71.3073 145.523 70.4531 146.555C69.6042 147.586 68.487 148.102 67.1016 148.102C66.2161 148.102 65.388 147.802 64.6172 147.203V147.164C65.263 147.638 66.0729 147.875 67.0469 147.875C68.3542 147.875 69.4271 147.383 70.2656 146.398C71.1042 145.414 71.5234 144.156 71.5234 142.625C71.5234 141.484 71.3307 140.487 70.9453 139.633C70.5651 138.779 70.0234 138.141 69.3203 137.719V137.633ZM82.9531 137.336L81.8828 138.422V146.445L82.8438 147.359H79.25L80.3359 146.445V141.188L77.8594 148H77.1094L77.0469 147.789H77.7266L80.3359 140.523V139.328L77.4297 147.352H76.8828L74.7422 141.047V145.18C74.7422 145.732 74.7786 146.122 74.8516 146.352C74.9245 146.581 75.0964 146.833 75.3672 147.109L76.0703 148H71.9844L71.8438 147.789H75.6797L75.3906 147.359H71.9062L72.0703 147.273C72.6484 146.956 73.0286 146.635 73.2109 146.312C73.3984 145.984 73.4922 145.469 73.4922 144.766V138.305L72.4609 137.336H76.5L75.3672 138.359L77.5781 144.898L77.8594 144.219L75.8594 138.422L76.8828 137.664L77.0469 137.797L76.0703 138.484L77.9297 143.93L79.9453 138.359L78.9922 137.336H82.9531ZM74.1094 139.188V144.797C74.1094 145.656 74.1901 146.247 74.3516 146.57C74.5182 146.893 74.8594 147.128 75.375 147.273L75.3047 147.156C74.7943 146.802 74.5391 146.292 74.5391 145.625V145.047V140.43L74.1094 139.188ZM83.3906 137.945L82.5078 138.578V146.453L83.8672 148H79.7188L79.6094 147.789H83.3906L82.3047 146.562V138.445L83.2266 137.812L83.3906 137.945ZM84.5703 137.336H88.0781C89.5677 137.336 90.6276 137.542 91.2578 137.953C92.0599 138.469 92.4609 139.185 92.4609 140.102C92.4609 140.659 92.3073 141.143 92 141.555C91.6927 141.966 91.263 142.263 90.7109 142.445C90.1589 142.628 89.2812 142.719 88.0781 142.719H87.1172V146.5L88.0703 147.359H84.4375L85.5234 146.445V143.312C85.4609 143.307 85.4167 143.305 85.3906 143.305C85.0156 143.305 84.6562 143.385 84.3125 143.547L84.2422 143.406C84.5911 143.208 84.9036 143.109 85.1797 143.109H85.4609L85.5234 143.102V142.719C85.4036 142.703 85.3229 142.695 85.2812 142.695C84.724 142.695 84.2786 142.831 83.9453 143.102L83.8672 142.984C84.1849 142.401 84.6953 142.109 85.3984 142.109H85.5234V138.281L84.5703 137.336ZM87.1172 138.141V142.055H87.2188L87.4219 142.062C87.4427 142.062 87.4766 142.06 87.5234 142.055V138.57H88.3828C89.0495 138.57 89.5182 138.63 89.7891 138.75C90.0651 138.865 90.2995 139.107 90.4922 139.477C90.2995 139.211 90.0573 139.026 89.7656 138.922C89.4792 138.812 89.0729 138.758 88.5469 138.758H87.7422V142.055C88.7734 142.055 89.5286 141.904 90.0078 141.602C90.4922 141.299 90.7344 140.826 90.7344 140.18C90.7344 139.456 90.5182 138.93 90.0859 138.602C89.6589 138.273 88.9688 138.109 88.0156 138.109C87.7708 138.109 87.4714 138.12 87.1172 138.141ZM92.0625 138.172C92.3802 138.328 92.6354 138.604 92.8281 139C93.0208 139.391 93.1172 139.836 93.1172 140.336C93.1172 141.466 92.6797 142.279 91.8047 142.773C91.1432 143.148 90.013 143.336 88.4141 143.336C88.1484 143.336 87.9245 143.331 87.7422 143.32V146.547L88.9688 148H85.0547L84.8438 147.789H88.5234L87.5234 146.633V143.109C87.9766 143.135 88.4583 143.148 88.9688 143.148C90.3125 143.148 91.3099 142.911 91.9609 142.438C92.612 141.964 92.9375 141.237 92.9375 140.258C92.9375 139.852 92.875 139.5 92.75 139.203C92.625 138.901 92.3958 138.557 92.0625 138.172ZM93.6016 137.336H97.3359L96.2344 138.406V146.758H96.2969L96.5781 146.781H96.6484V138.484L97.4922 137.633L97.6016 137.805L96.8438 138.578V146.781C97.0781 146.802 97.3021 146.812 97.5156 146.812C98.3438 146.812 98.9688 146.63 99.3906 146.266C99.8177 145.896 100.104 145.289 100.25 144.445C100.74 145.867 101.242 146.839 101.758 147.359H93.6016L94.6797 146.477V138.328L93.6016 137.336ZM102.523 147.297L102.172 148H94.0156L93.8203 147.789H102.086L102.312 147.297C101.74 146.594 101.281 145.81 100.938 144.945L100.906 144.859L101.156 144.953L101.211 145.086C101.56 145.857 101.977 146.568 102.461 147.219L102.523 147.297ZM110.836 137.336L110.711 137.484C110.18 138.135 109.758 138.883 109.445 139.727C109.393 139.607 109.354 139.518 109.328 139.461C109.042 138.836 108.734 138.432 108.406 138.25C108.078 138.068 107.49 137.977 106.641 137.977C106.25 137.977 105.781 137.99 105.234 138.016V141.609H105.734V138.43C106.13 138.393 106.508 138.375 106.867 138.375C107.529 138.375 108.016 138.445 108.328 138.586C108.641 138.727 108.919 139 109.164 139.406C109.091 139.354 109.039 139.315 109.008 139.289C108.586 138.956 108.281 138.758 108.094 138.695C107.906 138.633 107.536 138.602 106.984 138.602C106.818 138.602 106.521 138.612 106.094 138.633L105.93 138.641V141.609H107.367L108.375 140.227V143.594L107.367 142.289H105.234V146.672H105.734V142.656H107.43L107.633 142.859H105.93V146.672C106.992 146.672 107.747 146.596 108.195 146.445C108.643 146.294 108.995 145.997 109.25 145.555L109.664 144.844C109.68 144.812 109.711 144.755 109.758 144.672C109.893 145.245 110.06 145.703 110.258 146.047C110.461 146.391 110.794 146.792 111.258 147.25H102.5L103.688 146.344V142.859C103.25 142.911 102.854 143.047 102.5 143.266L102.391 143.102C102.708 142.872 103.141 142.724 103.688 142.656V142.289C103.599 142.279 103.536 142.273 103.5 142.273C102.969 142.273 102.484 142.469 102.047 142.859C102.286 142.026 102.833 141.609 103.688 141.609V138.273L102.5 137.336H110.836ZM111.211 137.883L111.156 137.953C110.521 138.807 110.096 139.523 109.883 140.102L109.75 139.938C110.099 139.13 110.549 138.391 111.102 137.719L111.211 137.883ZM108.914 140.484V143.938L108.719 143.836V140.383L108.914 140.484ZM112.148 147.297L111.742 148H103.211L103.086 147.789H111.641L111.906 147.297C111.156 146.604 110.628 145.865 110.32 145.078L110.57 145.172C110.857 145.839 111.341 146.505 112.023 147.172L112.148 147.297ZM121.031 137.336C120.984 137.424 120.953 137.484 120.938 137.516L120.406 138.453C120.224 138.786 120.055 139.203 119.898 139.703L119.883 139.742L119.805 139.688L119.781 139.586C119.63 138.992 119.414 138.581 119.133 138.352C118.857 138.122 118.432 138.008 117.859 138.008C117.625 138.008 117.391 138.018 117.156 138.039H117.062V146.508L117.984 147.359H114.414L115.508 146.445V138.672L114.953 138.664C114.417 138.664 114.034 138.771 113.805 138.984C113.581 139.193 113.448 139.562 113.406 140.094H113.203C113.26 139.484 113.417 139.06 113.672 138.82C113.932 138.581 114.359 138.461 114.953 138.461L115.422 138.469H115.508V138.086C115.242 138.055 114.99 138.039 114.75 138.039C114.078 138.039 113.594 138.177 113.297 138.453C113 138.724 112.836 139.185 112.805 139.836H112.711C112.487 139.112 112.141 138.305 111.672 137.414L111.625 137.336H121.031ZM121.523 137.828C121.164 138.286 120.786 139.047 120.391 140.109L120.359 140.188L120.188 140.039L120.211 139.969C120.596 138.891 120.969 138.141 121.328 137.719L121.367 137.672L121.523 137.828ZM119.438 139.047C119.036 138.786 118.568 138.656 118.031 138.656C117.911 138.656 117.786 138.664 117.656 138.68L117.688 146.531L118.93 148H114.938L114.758 147.789H118.5L117.453 146.594V138.453L117.875 138.445C118.38 138.445 118.737 138.487 118.945 138.57C119.159 138.648 119.323 138.807 119.438 139.047ZM121.586 137.336H125.289L124.242 138.398V146.531L125.227 147.359H121.586L122.672 146.461V138.312L121.586 137.336ZM125.641 137.781L124.844 138.57V146.531L126.156 148H122.094L121.898 147.789H125.695L124.625 146.609V138.5L125.508 137.625L125.641 137.781ZM132.531 139.078L132.398 139C131.898 138.724 131.44 138.586 131.023 138.586C129.654 138.586 128.969 139.932 128.969 142.625C128.969 144.594 129.393 145.898 130.242 146.539L130.172 146.617C129.651 146.247 129.279 145.763 129.055 145.164C128.836 144.56 128.727 143.745 128.727 142.719C128.727 139.828 129.487 138.383 131.008 138.383C131.701 138.383 132.208 138.615 132.531 139.078ZM130.859 137.234C132.125 137.234 133.135 137.714 133.891 138.672C134.651 139.63 135.031 140.911 135.031 142.516C135.031 144.031 134.656 145.24 133.906 146.141C133.161 147.042 132.159 147.492 130.898 147.492C129.904 147.492 129.018 147.174 128.242 146.539C127.102 145.602 126.531 144.214 126.531 142.375C126.531 140.802 126.922 139.552 127.703 138.625C128.484 137.698 129.536 137.234 130.859 137.234ZM130.859 137.906C129.099 137.906 128.219 139.453 128.219 142.547C128.219 145.406 129.086 146.836 130.82 146.836C131.628 146.836 132.242 146.458 132.664 145.703C133.086 144.943 133.297 143.833 133.297 142.375C133.297 140.724 133.094 139.573 132.688 138.922C132.26 138.245 131.651 137.906 130.859 137.906ZM133.352 137.633C134.096 137.992 134.685 138.607 135.117 139.477C135.549 140.346 135.766 141.352 135.766 142.492C135.766 144.169 135.339 145.523 134.484 146.555C133.635 147.586 132.518 148.102 131.133 148.102C130.247 148.102 129.419 147.802 128.648 147.203V147.164C129.294 147.638 130.104 147.875 131.078 147.875C132.385 147.875 133.458 147.383 134.297 146.398C135.135 145.414 135.555 144.156 135.555 142.625C135.555 141.484 135.362 140.487 134.977 139.633C134.596 138.779 134.055 138.141 133.352 137.719V137.633ZM145.375 137.336C144.781 137.643 144.398 137.924 144.227 138.18C143.966 138.576 143.836 139.172 143.836 139.969V140.477V147.359H142.516L138.828 140.203V144.445L138.82 144.797L138.914 145.922C139.018 146.443 139.255 146.828 139.625 147.078L139.688 147.133C138.969 146.893 138.609 146.125 138.609 144.828L138.617 144.094V139.82L138.195 139V143.5C138.195 144.927 138.289 145.862 138.477 146.305C138.664 146.747 139.104 147.07 139.797 147.273L140.477 148H136.242L136.117 147.789H140.031L139.625 147.359H135.984C136.62 147.13 137.042 146.823 137.25 146.438C137.458 146.052 137.562 145.391 137.562 144.453V138.203L136.523 137.336H140.477L139.367 138.078L143.148 145.453V144.516L139.906 138.203L141 137.461L141.148 137.609L140.18 138.266L143.148 144.094V140.445V140.031C143.148 139.125 143.073 138.521 142.922 138.219C142.776 137.911 142.411 137.617 141.828 137.336H145.375ZM145.648 137.914L145.508 138.148C145.107 138.242 144.833 138.417 144.688 138.672C144.547 138.922 144.477 139.346 144.477 139.945V148H142.797L142.695 147.789H144.266V140.023C144.266 139.289 144.359 138.779 144.547 138.492C144.74 138.201 145.107 138.008 145.648 137.914Z",
    fill: "url(#paint27_linear_1375_1010)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 357,
    width: 131,
    height: 1,
    fill: "url(#paint28_linear_1375_1010)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 393.5,
    cy: 357.5,
    r: 1.5,
    fill: "url(#paint29_linear_1375_1010)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.5,
    cy: 357.5,
    r: 1.5,
    fill: "url(#paint30_linear_1375_1010)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 218,
    width: 178,
    height: 1,
    fill: "url(#paint31_linear_1375_1010)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M422.609 120.169H424.885V126.997H422.609V120.169ZM426.53 120.169H428.652L431.419 123.946V120.169H433.559V126.997H431.419L428.665 123.248V126.997H426.53V120.169ZM439.489 125.87H436.901L436.545 126.997H434.225L436.987 120.169H439.463L442.226 126.997H439.85L439.489 125.87H439.489ZM439.013 124.393L438.2 121.938L437.393 124.393H439.013H439.013ZM442.928 120.169H445.916L447.069 124.323L448.218 120.169H451.195V126.997H449.34V121.79L447.901 126.997H446.222L444.788 121.79V126.997H442.928V120.169H442.928ZM452.674 120.169H456.048C456.712 120.169 457.249 120.253 457.66 120.42C458.069 120.588 458.408 120.829 458.675 121.142C458.942 121.457 459.135 121.821 459.257 122.237C459.376 122.654 459.436 123.094 459.436 123.56C459.436 124.29 459.347 124.856 459.168 125.258C458.99 125.66 458.742 125.997 458.423 126.267C458.107 126.539 457.766 126.72 457.402 126.811C456.904 126.935 456.452 126.997 456.048 126.997H452.674V120.169L452.674 120.169ZM454.944 121.716V125.446H455.501C455.976 125.446 456.313 125.398 456.514 125.299C456.714 125.202 456.871 125.03 456.986 124.787C457.099 124.544 457.155 124.148 457.155 123.601C457.155 122.878 457.029 122.383 456.775 122.116C456.52 121.849 456.099 121.716 455.511 121.716H454.944ZM464.71 125.87H462.123L461.767 126.997H459.447L462.208 120.169H464.684L467.448 126.997H465.071L464.71 125.87H464.71ZM464.235 124.393L463.422 121.938L462.614 124.393H464.235H464.235ZM468.205 126.997V120.169H471.99C472.691 120.169 473.229 120.224 473.598 120.337C473.97 120.449 474.269 120.655 474.497 120.959C474.724 121.261 474.837 121.63 474.837 122.064C474.837 122.444 474.75 122.77 474.577 123.045C474.403 123.32 474.163 123.542 473.86 123.714C473.665 123.822 473.4 123.913 473.063 123.983C473.333 124.067 473.53 124.151 473.655 124.236C473.737 124.291 473.858 124.411 474.017 124.593C474.177 124.778 474.283 124.918 474.336 125.018L475.434 126.997H472.868L471.654 124.91C471.5 124.641 471.363 124.465 471.242 124.383C471.079 124.278 470.893 124.226 470.686 124.226H470.485V126.997H468.205L468.205 126.997ZM470.486 122.935H471.444C471.547 122.935 471.747 122.905 472.045 122.843C472.195 122.814 472.318 122.743 472.414 122.628C472.508 122.514 472.556 122.382 472.556 122.232C472.556 122.011 472.481 121.843 472.33 121.725C472.18 121.606 471.897 121.547 471.483 121.547H470.486V122.935L470.486 122.935Z",
    fill: "#0077BD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M422.609 132.438V128.797H423.908L424.687 131.281L425.458 128.797H426.759V132.438H425.954V129.571L425.1 132.438H424.265L423.415 129.571V132.438H422.609ZM427.616 128.797H428.483V130.769C428.483 131.082 428.494 131.285 428.515 131.378C428.552 131.527 428.641 131.646 428.78 131.736C428.92 131.827 429.111 131.872 429.353 131.872C429.599 131.872 429.785 131.83 429.91 131.744C430.036 131.659 430.111 131.554 430.136 131.43C430.162 131.306 430.174 131.1 430.174 130.811V128.797H431.041V130.71C431.041 131.147 431.018 131.456 430.971 131.636C430.924 131.817 430.838 131.969 430.712 132.093C430.586 132.217 430.417 132.316 430.207 132.39C429.996 132.464 429.719 132.5 429.379 132.5C428.969 132.5 428.658 132.46 428.446 132.38C428.234 132.299 428.067 132.195 427.944 132.067C427.821 131.939 427.74 131.804 427.701 131.663C427.644 131.455 427.616 131.147 427.616 130.739V128.797V128.797ZM431.979 132.438V128.826H432.847V131.824H435.004V132.438H431.979ZM436.144 132.438V129.413H434.87V128.797H438.284V129.413H437.013V132.438H436.144ZM438.817 132.438V128.797H439.685V132.438H438.817ZM440.292 131.254L441.136 131.183C441.186 131.424 441.289 131.6 441.445 131.713C441.601 131.825 441.81 131.882 442.074 131.882C442.353 131.882 442.564 131.832 442.705 131.731C442.847 131.631 442.918 131.514 442.918 131.38C442.918 131.294 442.888 131.221 442.828 131.161C442.769 131.099 442.665 131.047 442.516 131.003C442.415 130.972 442.183 130.92 441.822 130.843C441.356 130.746 441.03 130.626 440.843 130.483C440.579 130.283 440.447 130.039 440.447 129.75C440.447 129.565 440.509 129.392 440.633 129.23C440.757 129.069 440.936 128.946 441.169 128.861C441.403 128.777 441.685 128.735 442.015 128.735C442.555 128.735 442.96 128.835 443.233 129.035C443.505 129.236 443.648 129.503 443.662 129.838L442.795 129.87C442.758 129.683 442.678 129.548 442.556 129.466C442.434 129.384 442.251 129.343 442.007 129.343C441.755 129.343 441.556 129.387 441.414 129.475C441.323 129.531 441.277 129.606 441.277 129.7C441.277 129.787 441.319 129.861 441.406 129.922C441.515 130 441.781 130.081 442.203 130.165C442.625 130.25 442.937 130.337 443.139 130.427C443.341 130.518 443.499 130.641 443.615 130.798C443.729 130.954 443.786 131.148 443.786 131.377C443.786 131.586 443.718 131.782 443.581 131.963C443.444 132.146 443.25 132.281 443 132.369C442.75 132.458 442.438 132.502 442.065 132.502C441.522 132.502 441.104 132.397 440.813 132.184C440.522 131.971 440.348 131.661 440.292 131.254V131.254ZM444.516 132.438V128.797H445.907C446.435 128.797 446.779 128.815 446.939 128.852C447.185 128.906 447.392 129.025 447.558 129.208C447.724 129.391 447.807 129.627 447.807 129.917C447.807 130.14 447.759 130.329 447.663 130.48C447.567 130.633 447.446 130.753 447.298 130.84C447.151 130.926 447.001 130.984 446.849 131.012C446.642 131.047 446.342 131.065 445.949 131.065H445.383V132.438H444.516ZM445.383 129.413V130.446H445.857C446.2 130.446 446.429 130.427 446.544 130.389C446.659 130.351 446.749 130.291 446.815 130.21C446.88 130.129 446.913 130.034 446.913 129.927C446.913 129.794 446.867 129.685 446.775 129.599C446.684 129.513 446.567 129.459 446.427 129.437C446.323 129.42 446.114 129.413 445.802 129.413H445.383H445.383ZM448.52 132.438V128.797H451.705V129.413H449.387V130.22H451.544V130.833H449.387V131.824H451.787V132.438H448.52ZM455.272 131.099L456.113 131.325C455.984 131.723 455.77 132.018 455.47 132.211C455.17 132.403 454.789 132.5 454.328 132.5C453.758 132.5 453.289 132.335 452.922 132.005C452.554 131.674 452.37 131.222 452.37 130.65C452.37 130.044 452.555 129.573 452.925 129.237C453.294 128.903 453.779 128.735 454.381 128.735C454.907 128.735 455.334 128.866 455.662 129.13C455.858 129.285 456.004 129.509 456.102 129.8L455.243 129.974C455.193 129.785 455.087 129.636 454.924 129.527C454.763 129.417 454.567 129.363 454.337 129.363C454.019 129.363 453.76 129.46 453.562 129.654C453.364 129.847 453.265 130.161 453.265 130.595C453.265 131.055 453.362 131.383 453.558 131.578C453.753 131.774 454.007 131.872 454.319 131.872C454.55 131.872 454.748 131.81 454.914 131.685C455.08 131.561 455.2 131.366 455.273 131.099H455.272ZM456.831 132.438V128.797H457.699V132.438H456.831ZM462.401 132.438H461.456L461.081 131.611H459.363L459.009 132.438H458.089L459.762 128.797H460.68L462.401 132.438ZM460.803 130.998L460.211 129.646L459.63 130.998H460.803ZM462.884 132.438V128.826H463.751V131.824H465.908V132.438H462.884ZM466.5 132.438V128.797H467.368V132.438H466.5ZM469.162 132.438V129.413H467.887V128.797H471.301V129.413H470.03V132.438H469.162H469.162ZM472.989 132.438V130.905L471.415 128.797H472.433L473.444 130.237L474.435 128.797H475.434L473.854 130.91V132.438H472.989H472.989Z",
    fill: "#0077BD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M422.609 137.931V134.039H423.31V135.57H424.68V134.039H425.379V137.931H424.68V136.229H423.31V137.931H422.609ZM430.135 136.009C430.135 135.612 430.187 135.28 430.293 135.01C430.372 134.813 430.479 134.634 430.615 134.477C430.752 134.32 430.901 134.203 431.063 134.127C431.279 134.024 431.528 133.973 431.81 133.973C432.321 133.973 432.729 134.15 433.035 134.507C433.342 134.862 433.495 135.357 433.495 135.99C433.495 136.619 433.343 137.11 433.039 137.466C432.735 137.82 432.328 137.997 431.82 137.997C431.304 137.997 430.895 137.821 430.59 137.468C430.286 137.115 430.135 136.628 430.135 136.009ZM430.855 135.983C430.855 136.423 430.946 136.758 431.127 136.985C431.308 137.213 431.538 137.326 431.818 137.326C432.096 137.326 432.325 137.214 432.504 136.987C432.682 136.761 432.772 136.423 432.772 135.972C432.772 135.526 432.685 135.194 432.511 134.973C432.337 134.754 432.106 134.644 431.818 134.644C431.529 134.644 431.296 134.756 431.12 134.978C430.944 135.2 430.855 135.534 430.855 135.983H430.855ZM438.038 136.665L438.718 136.59C438.759 136.847 438.842 137.036 438.968 137.156C439.093 137.276 439.261 137.337 439.474 137.337C439.699 137.337 439.87 137.283 439.983 137.175C440.098 137.068 440.155 136.943 440.155 136.8C440.155 136.708 440.131 136.63 440.082 136.565C440.035 136.5 439.951 136.444 439.831 136.397C439.749 136.364 439.562 136.308 439.271 136.226C438.896 136.122 438.633 135.994 438.482 135.841C438.269 135.627 438.163 135.366 438.163 135.058C438.163 134.86 438.213 134.675 438.313 134.502C438.413 134.33 438.557 134.198 438.745 134.108C438.934 134.018 439.161 133.973 439.427 133.973C439.862 133.973 440.189 134.08 440.409 134.293C440.629 134.508 440.744 134.794 440.755 135.152L440.056 135.186C440.026 134.986 439.962 134.842 439.863 134.755C439.765 134.667 439.617 134.623 439.42 134.623C439.217 134.623 439.057 134.67 438.943 134.764C438.869 134.824 438.831 134.904 438.831 135.005C438.831 135.097 438.866 135.176 438.935 135.241C439.023 135.325 439.238 135.412 439.578 135.501C439.919 135.592 440.17 135.685 440.333 135.781C440.496 135.878 440.624 136.01 440.717 136.177C440.809 136.345 440.854 136.552 440.854 136.797C440.854 137.02 440.8 137.23 440.689 137.424C440.579 137.618 440.423 137.763 440.221 137.858C440.02 137.953 439.768 138 439.467 138C439.029 138 438.692 137.887 438.458 137.659C438.223 137.432 438.083 137.1 438.037 136.665H438.038ZM445.617 137.931V134.039H446.739C447.164 134.039 447.442 134.059 447.571 134.098C447.769 134.156 447.936 134.283 448.07 134.478C448.204 134.674 448.271 134.927 448.271 135.236C448.271 135.475 448.232 135.676 448.155 135.839C448.077 136.002 447.98 136.13 447.86 136.223C447.742 136.315 447.621 136.377 447.498 136.407C447.331 136.444 447.089 136.463 446.772 136.463H446.316V137.931H445.617H445.617ZM446.316 134.698V135.801H446.699C446.975 135.801 447.159 135.782 447.252 135.741C447.345 135.7 447.417 135.637 447.471 135.549C447.523 135.462 447.55 135.362 447.55 135.247C447.55 135.105 447.513 134.989 447.438 134.896C447.365 134.805 447.271 134.747 447.158 134.724C447.074 134.706 446.906 134.698 446.654 134.698H446.316V134.698ZM452.997 137.931V134.039H453.697V137.931H452.997ZM459.317 137.931V134.698H458.289V134.039H461.042V134.698H460.017V137.931H459.317H459.317ZM468.433 137.931H467.671L467.369 137.047H465.984L465.698 137.931H464.956L466.305 134.039H467.045L468.433 137.931ZM467.144 136.392L466.667 134.947L466.199 136.392H467.144H467.144ZM472.996 137.931V134.071H473.695V137.275H475.434V137.931H472.996V137.931Z",
    fill: "#0077BD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.734 116.901L460.371 117.097C460.273 117.456 460.11 117.722 459.882 117.896C459.655 118.07 459.367 118.157 459.017 118.157C458.584 118.157 458.228 118.009 457.949 117.713C457.671 117.418 457.531 117.013 457.531 116.5C457.531 115.957 457.672 115.536 457.951 115.235C458.231 114.935 458.6 114.785 459.056 114.785C459.455 114.785 459.779 114.903 460.028 115.139C460.177 115.279 460.287 115.479 460.362 115.741L459.711 115.895C459.672 115.727 459.592 115.594 459.47 115.496C459.347 115.398 459.198 115.349 459.024 115.349C458.782 115.349 458.586 115.436 458.435 115.609C458.284 115.782 458.209 116.063 458.209 116.451C458.209 116.862 458.284 117.156 458.431 117.33C458.58 117.506 458.773 117.593 459.01 117.593C459.185 117.593 459.336 117.538 459.462 117.426C459.588 117.315 459.679 117.14 459.734 116.901ZM460.913 118.103V114.844H461.573V118.103H460.913ZM462.191 118.103V114.844H463.18L463.764 117.066L464.341 114.844H465.332V118.103H464.722L464.719 115.537L464.077 118.103H463.443L462.803 115.537L462.801 118.103H462.191ZM465.991 118.103V114.844H468.403V115.395H466.651V116.118H468.28V116.669H466.651V117.552H468.467V118.103H465.991ZM469.759 118.103V115.395H468.795V114.844H471.379V115.395H470.419V118.103H469.759ZM471.797 116L471.679 115.394V114.844H472.357V115.394L472.256 116H471.797ZM472.716 117.047L473.358 116.983C473.396 117.198 473.474 117.355 473.591 117.456C473.709 117.556 473.867 117.606 474.067 117.606C474.278 117.606 474.437 117.562 474.544 117.472C474.651 117.383 474.705 117.278 474.705 117.158C474.705 117.081 474.682 117.016 474.637 116.961C474.592 116.907 474.513 116.86 474.401 116.821C474.325 116.793 474.15 116.746 473.877 116.678C473.526 116.59 473.279 116.482 473.138 116.354C472.938 116.174 472.839 115.955 472.839 115.697C472.839 115.531 472.886 115.374 472.979 115.229C473.073 115.085 473.208 114.975 473.385 114.899C473.562 114.823 473.774 114.785 474.024 114.785C474.431 114.785 474.739 114.875 474.944 115.057C475.15 115.238 475.258 115.479 475.269 115.782L474.609 115.804C474.581 115.636 474.521 115.515 474.429 115.442C474.337 115.368 474.199 115.331 474.016 115.331C473.826 115.331 473.678 115.371 473.571 115.45C473.502 115.5 473.467 115.568 473.467 115.653C473.467 115.73 473.499 115.796 473.564 115.851C473.647 115.921 473.848 115.994 474.168 116.07C474.487 116.145 474.723 116.224 474.875 116.304C475.028 116.386 475.148 116.496 475.235 116.636C475.321 116.776 475.364 116.949 475.364 117.155C475.364 117.341 475.313 117.517 475.209 117.68C475.105 117.843 474.958 117.964 474.769 118.043C474.579 118.123 474.343 118.162 474.06 118.162C473.648 118.162 473.332 118.067 473.111 117.877C472.89 117.687 472.759 117.41 472.716 117.047L472.716 117.047Z",
    fill: "#0077BD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.124 115.792V119.255H412V115.792H417.124Z",
    fill: "#ED3237"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.117 119.25H420.843V124.013H417.117V119.25Z",
    fill: "#ED3237"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.117 111H420.843V115.793H417.117V111Z",
    fill: "#ED3237"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.858 115.792L420.843 119.255V115.792H426.858Z",
    fill: "#0077BD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M410.94 371.58H408.03L407.53 373H406.34L408.83 366.04H410.15L412.64 373H411.44L410.94 371.58ZM410.62 370.65L409.49 367.42L408.35 370.65H410.62ZM418.713 367.49V373H417.573V372.35C417.393 372.577 417.156 372.757 416.863 372.89C416.576 373.017 416.269 373.08 415.943 373.08C415.509 373.08 415.119 372.99 414.773 372.81C414.433 372.63 414.163 372.363 413.963 372.01C413.769 371.657 413.673 371.23 413.673 370.73V367.49H414.803V370.56C414.803 371.053 414.926 371.433 415.173 371.7C415.419 371.96 415.756 372.09 416.183 372.09C416.609 372.09 416.946 371.96 417.193 371.7C417.446 371.433 417.573 371.053 417.573 370.56V367.49H418.713ZM421.547 368.42V371.47C421.547 371.677 421.593 371.827 421.687 371.92C421.787 372.007 421.953 372.05 422.187 372.05H422.887V373H421.987C421.473 373 421.08 372.88 420.807 372.64C420.533 372.4 420.397 372.01 420.397 371.47V368.42H419.747V367.49H420.397V366.12H421.547V367.49H422.887V368.42H421.547ZM426.788 367.4C427.208 367.4 427.581 367.49 427.908 367.67C428.241 367.85 428.501 368.117 428.688 368.47C428.881 368.823 428.978 369.25 428.978 369.75V373H427.848V369.92C427.848 369.427 427.724 369.05 427.478 368.79C427.231 368.523 426.894 368.39 426.468 368.39C426.041 368.39 425.701 368.523 425.448 368.79C425.201 369.05 425.078 369.427 425.078 369.92V373H423.938V365.6H425.078V368.13C425.271 367.897 425.514 367.717 425.808 367.59C426.108 367.463 426.434 367.4 426.788 367.4ZM432.822 373.09C432.302 373.09 431.832 372.973 431.412 372.74C430.992 372.5 430.662 372.167 430.422 371.74C430.182 371.307 430.062 370.807 430.062 370.24C430.062 369.68 430.185 369.183 430.432 368.75C430.678 368.317 431.015 367.983 431.442 367.75C431.868 367.517 432.345 367.4 432.872 367.4C433.398 367.4 433.875 367.517 434.302 367.75C434.728 367.983 435.065 368.317 435.312 368.75C435.558 369.183 435.682 369.68 435.682 370.24C435.682 370.8 435.555 371.297 435.302 371.73C435.048 372.163 434.702 372.5 434.262 372.74C433.828 372.973 433.348 373.09 432.822 373.09ZM432.822 372.1C433.115 372.1 433.388 372.03 433.642 371.89C433.902 371.75 434.112 371.54 434.272 371.26C434.432 370.98 434.512 370.64 434.512 370.24C434.512 369.84 434.435 369.503 434.282 369.23C434.128 368.95 433.925 368.74 433.672 368.6C433.418 368.46 433.145 368.39 432.852 368.39C432.558 368.39 432.285 368.46 432.032 368.6C431.785 368.74 431.588 368.95 431.442 369.23C431.295 369.503 431.222 369.84 431.222 370.24C431.222 370.833 431.372 371.293 431.672 371.62C431.978 371.94 432.362 372.1 432.822 372.1ZM437.949 368.29C438.115 368.01 438.335 367.793 438.609 367.64C438.889 367.48 439.219 367.4 439.599 367.4V368.58H439.309C438.862 368.58 438.522 368.693 438.289 368.92C438.062 369.147 437.949 369.54 437.949 370.1V373H436.809V367.49H437.949V368.29ZM441.226 366.76C441.02 366.76 440.846 366.69 440.706 366.55C440.566 366.41 440.496 366.237 440.496 366.03C440.496 365.823 440.566 365.65 440.706 365.51C440.846 365.37 441.02 365.3 441.226 365.3C441.426 365.3 441.596 365.37 441.736 365.51C441.876 365.65 441.946 365.823 441.946 366.03C441.946 366.237 441.876 366.41 441.736 366.55C441.596 366.69 441.426 366.76 441.226 366.76ZM441.786 367.49V373H440.646V367.49H441.786ZM444.293 372.07H446.793V373H442.973V372.07L445.483 368.42H442.973V367.49H446.793V368.42L444.293 372.07ZM453.04 370.11C453.04 370.317 453.027 370.503 453 370.67H448.79C448.824 371.11 448.987 371.463 449.28 371.73C449.574 371.997 449.934 372.13 450.36 372.13C450.974 372.13 451.407 371.873 451.66 371.36H452.89C452.724 371.867 452.42 372.283 451.98 372.61C451.547 372.93 451.007 373.09 450.36 373.09C449.834 373.09 449.36 372.973 448.94 372.74C448.527 372.5 448.2 372.167 447.96 371.74C447.727 371.307 447.61 370.807 447.61 370.24C447.61 369.673 447.724 369.177 447.95 368.75C448.184 368.317 448.507 367.983 448.92 367.75C449.34 367.517 449.82 367.4 450.36 367.4C450.88 367.4 451.344 367.513 451.75 367.74C452.157 367.967 452.474 368.287 452.7 368.7C452.927 369.107 453.04 369.577 453.04 370.11ZM451.85 369.75C451.844 369.33 451.694 368.993 451.4 368.74C451.107 368.487 450.744 368.36 450.31 368.36C449.917 368.36 449.58 368.487 449.3 368.74C449.02 368.987 448.854 369.323 448.8 369.75H451.85ZM453.782 370.22C453.782 369.667 453.895 369.177 454.122 368.75C454.355 368.323 454.669 367.993 455.062 367.76C455.462 367.52 455.905 367.4 456.392 367.4C456.752 367.4 457.105 367.48 457.452 367.64C457.805 367.793 458.085 368 458.292 368.26V365.6H459.442V373H458.292V372.17C458.105 372.437 457.845 372.657 457.512 372.83C457.185 373.003 456.809 373.09 456.382 373.09C455.902 373.09 455.462 372.97 455.062 372.73C454.669 372.483 454.355 372.143 454.122 371.71C453.895 371.27 453.782 370.773 453.782 370.22ZM458.292 370.24C458.292 369.86 458.212 369.53 458.052 369.25C457.899 368.97 457.695 368.757 457.442 368.61C457.189 368.463 456.915 368.39 456.622 368.39C456.329 368.39 456.055 368.463 455.802 368.61C455.549 368.75 455.342 368.96 455.182 369.24C455.029 369.513 454.952 369.84 454.952 370.22C454.952 370.6 455.029 370.933 455.182 371.22C455.342 371.507 455.549 371.727 455.802 371.88C456.062 372.027 456.335 372.1 456.622 372.1C456.915 372.1 457.189 372.027 457.442 371.88C457.695 371.733 457.899 371.52 458.052 371.24C458.212 370.953 458.292 370.62 458.292 370.24ZM465.827 373.07C465.36 373.07 464.94 372.99 464.567 372.83C464.194 372.663 463.9 372.43 463.687 372.13C463.474 371.83 463.367 371.48 463.367 371.08H464.587C464.614 371.38 464.73 371.627 464.937 371.82C465.15 372.013 465.447 372.11 465.827 372.11C466.22 372.11 466.527 372.017 466.747 371.83C466.967 371.637 467.077 371.39 467.077 371.09C467.077 370.857 467.007 370.667 466.867 370.52C466.734 370.373 466.564 370.26 466.357 370.18C466.157 370.1 465.877 370.013 465.517 369.92C465.064 369.8 464.694 369.68 464.407 369.56C464.127 369.433 463.887 369.24 463.687 368.98C463.487 368.72 463.387 368.373 463.387 367.94C463.387 367.54 463.487 367.19 463.687 366.89C463.887 366.59 464.167 366.36 464.527 366.2C464.887 366.04 465.304 365.96 465.777 365.96C466.45 365.96 467 366.13 467.427 366.47C467.86 366.803 468.1 367.263 468.147 367.85H466.887C466.867 367.597 466.747 367.38 466.527 367.2C466.307 367.02 466.017 366.93 465.657 366.93C465.33 366.93 465.064 367.013 464.857 367.18C464.65 367.347 464.547 367.587 464.547 367.9C464.547 368.113 464.61 368.29 464.737 368.43C464.87 368.563 465.037 368.67 465.237 368.75C465.437 368.83 465.71 368.917 466.057 369.01C466.517 369.137 466.89 369.263 467.177 369.39C467.47 369.517 467.717 369.713 467.917 369.98C468.124 370.24 468.227 370.59 468.227 371.03C468.227 371.383 468.13 371.717 467.937 372.03C467.75 372.343 467.474 372.597 467.107 372.79C466.747 372.977 466.32 373.07 465.827 373.07ZM470.152 366.76C469.946 366.76 469.772 366.69 469.632 366.55C469.492 366.41 469.422 366.237 469.422 366.03C469.422 365.823 469.492 365.65 469.632 365.51C469.772 365.37 469.946 365.3 470.152 365.3C470.352 365.3 470.522 365.37 470.662 365.51C470.802 365.65 470.872 365.823 470.872 366.03C470.872 366.237 470.802 366.41 470.662 366.55C470.522 366.69 470.352 366.76 470.152 366.76ZM470.712 367.49V373H469.572V367.49H470.712ZM474.429 367.4C474.856 367.4 475.232 367.487 475.559 367.66C475.892 367.827 476.152 368.037 476.339 368.29V367.49H477.489V373.09C477.489 373.597 477.382 374.047 477.169 374.44C476.956 374.84 476.646 375.153 476.239 375.38C475.839 375.607 475.359 375.72 474.799 375.72C474.052 375.72 473.432 375.543 472.939 375.19C472.446 374.843 472.166 374.37 472.099 373.77H473.229C473.316 374.057 473.499 374.287 473.779 374.46C474.066 374.64 474.406 374.73 474.799 374.73C475.259 374.73 475.629 374.59 475.909 374.31C476.196 374.03 476.339 373.623 476.339 373.09V372.17C476.146 372.43 475.882 372.65 475.549 372.83C475.222 373.003 474.849 373.09 474.429 373.09C473.949 373.09 473.509 372.97 473.109 372.73C472.716 372.483 472.402 372.143 472.169 371.71C471.942 371.27 471.829 370.773 471.829 370.22C471.829 369.667 471.942 369.177 472.169 368.75C472.402 368.323 472.716 367.993 473.109 367.76C473.509 367.52 473.949 367.4 474.429 367.4ZM476.339 370.24C476.339 369.86 476.259 369.53 476.099 369.25C475.946 368.97 475.742 368.757 475.489 368.61C475.236 368.463 474.962 368.39 474.669 368.39C474.376 368.39 474.102 368.463 473.849 368.61C473.596 368.75 473.389 368.96 473.229 369.24C473.076 369.513 472.999 369.84 472.999 370.22C472.999 370.6 473.076 370.933 473.229 371.22C473.389 371.507 473.596 371.727 473.849 371.88C474.109 372.027 474.382 372.1 474.669 372.1C474.962 372.1 475.236 372.027 475.489 371.88C475.742 371.733 475.946 371.52 476.099 371.24C476.259 370.953 476.339 370.62 476.339 370.24ZM481.766 367.4C482.2 367.4 482.586 367.49 482.926 367.67C483.273 367.85 483.543 368.117 483.736 368.47C483.93 368.823 484.026 369.25 484.026 369.75V373H482.896V369.92C482.896 369.427 482.773 369.05 482.526 368.79C482.28 368.523 481.943 368.39 481.516 368.39C481.09 368.39 480.75 368.523 480.496 368.79C480.25 369.05 480.126 369.427 480.126 369.92V373H478.986V367.49H480.126V368.12C480.313 367.893 480.55 367.717 480.836 367.59C481.13 367.463 481.44 367.4 481.766 367.4ZM485.1 370.22C485.1 369.667 485.214 369.177 485.44 368.75C485.674 368.323 485.987 367.993 486.38 367.76C486.78 367.52 487.22 367.4 487.7 367.4C488.134 367.4 488.51 367.487 488.83 367.66C489.157 367.827 489.417 368.037 489.61 368.29V367.49H490.76V373H489.61V372.18C489.417 372.44 489.154 372.657 488.82 372.83C488.487 373.003 488.107 373.09 487.68 373.09C487.207 373.09 486.774 372.97 486.38 372.73C485.987 372.483 485.674 372.143 485.44 371.71C485.214 371.27 485.1 370.773 485.1 370.22ZM489.61 370.24C489.61 369.86 489.53 369.53 489.37 369.25C489.217 368.97 489.014 368.757 488.76 368.61C488.507 368.463 488.234 368.39 487.94 368.39C487.647 368.39 487.374 368.463 487.12 368.61C486.867 368.75 486.66 368.96 486.5 369.24C486.347 369.513 486.27 369.84 486.27 370.22C486.27 370.6 486.347 370.933 486.5 371.22C486.66 371.507 486.867 371.727 487.12 371.88C487.38 372.027 487.654 372.1 487.94 372.1C488.234 372.1 488.507 372.027 488.76 371.88C489.014 371.733 489.217 371.52 489.37 371.24C489.53 370.953 489.61 370.62 489.61 370.24ZM493.588 368.42V371.47C493.588 371.677 493.634 371.827 493.728 371.92C493.828 372.007 493.994 372.05 494.228 372.05H494.928V373H494.028C493.514 373 493.121 372.88 492.848 372.64C492.574 372.4 492.438 372.01 492.438 371.47V368.42H491.788V367.49H492.438V366.12H493.588V367.49H494.928V368.42H493.588ZM500.969 367.49V373H499.829V372.35C499.649 372.577 499.412 372.757 499.119 372.89C498.832 373.017 498.525 373.08 498.199 373.08C497.765 373.08 497.375 372.99 497.029 372.81C496.689 372.63 496.419 372.363 496.219 372.01C496.025 371.657 495.929 371.23 495.929 370.73V367.49H497.059V370.56C497.059 371.053 497.182 371.433 497.429 371.7C497.675 371.96 498.012 372.09 498.439 372.09C498.865 372.09 499.202 371.96 499.449 371.7C499.702 371.433 499.829 371.053 499.829 370.56V367.49H500.969ZM503.613 368.29C503.779 368.01 503.999 367.793 504.273 367.64C504.553 367.48 504.883 367.4 505.263 367.4V368.58H504.973C504.526 368.58 504.186 368.693 503.953 368.92C503.726 369.147 503.613 369.54 503.613 370.1V373H502.473V367.49H503.613V368.29ZM511.361 370.11C511.361 370.317 511.347 370.503 511.321 370.67H507.111C507.144 371.11 507.307 371.463 507.601 371.73C507.894 371.997 508.254 372.13 508.681 372.13C509.294 372.13 509.727 371.873 509.981 371.36H511.211C511.044 371.867 510.741 372.283 510.301 372.61C509.867 372.93 509.327 373.09 508.681 373.09C508.154 373.09 507.681 372.973 507.261 372.74C506.847 372.5 506.521 372.167 506.281 371.74C506.047 371.307 505.931 370.807 505.931 370.24C505.931 369.673 506.044 369.177 506.271 368.75C506.504 368.317 506.827 367.983 507.241 367.75C507.661 367.517 508.141 367.4 508.681 367.4C509.201 367.4 509.664 367.513 510.071 367.74C510.477 367.967 510.794 368.287 511.021 368.7C511.247 369.107 511.361 369.577 511.361 370.11ZM510.171 369.75C510.164 369.33 510.014 368.993 509.721 368.74C509.427 368.487 509.064 368.36 508.631 368.36C508.237 368.36 507.901 368.487 507.621 368.74C507.341 368.987 507.174 369.323 507.121 369.75H510.171Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1375_1010",
    x1: 0,
    y1: 199.862,
    x2: 565.22,
    y2: 199.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1375_1010",
    x1: 3.80972e-7,
    y1: 119.277,
    x2: 565.22,
    y2: 119.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23529,
    stopColor: "#B97800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45989,
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53019,
    stopColor: "#D8A232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60651,
    stopColor: "#B4811C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67837,
    stopColor: "#9B690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74324,
    stopColor: "#8B5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79501,
    stopColor: "#865600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82876,
    stopColor: "#936208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89144,
    stopColor: "#B6831D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97556,
    stopColor: "#EDB73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC74A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(313.777 133.076) rotate(14.9087) scale(297.735 81.4788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1375_1010",
    x1: 283.258,
    y1: 492.003,
    x2: -213.382,
    y2: 161.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1375_1010",
    x1: -37.2168,
    y1: 305.788,
    x2: 206.117,
    y2: 455.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23529,
    stopColor: "#B97800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45989,
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53019,
    stopColor: "#D8A232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60651,
    stopColor: "#B4811C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67837,
    stopColor: "#9B690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74324,
    stopColor: "#8B5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79501,
    stopColor: "#865600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82876,
    stopColor: "#936208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89144,
    stopColor: "#B6831D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97556,
    stopColor: "#EDB73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC74A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1375_1010",
    x1: 81.2278,
    y1: 387.371,
    x2: 96.2278,
    y2: 358.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1375_1010",
    x1: -2.19747,
    y1: 331.931,
    x2: 119.802,
    y2: 411.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265.11 20.3617) scale(187.032 187.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330.687 24.4055) rotate(14.596) scale(285.515 57.9313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(313.777 90.8832) rotate(14.9087) scale(287.645 78.7176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.277 14.5284) scale(142.972 142.972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(453.895 66.1867) rotate(28.4029) scale(134.707 36.4086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.265 33.7501) rotate(31.6125) scale(108.478 70.1536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16039,
    stopColor: "#164163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(471.743 64.8778) rotate(31.6125) scale(106.23 68.6999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.675 134.892) scale(66.7152 66.7152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15054,
    stopColor: "#15344D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22655,
    stopColor: "#395369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36276,
    stopColor: "#738696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49443,
    stopColor: "#A4B0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61823,
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73226,
    stopColor: "#E5E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83308,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91003,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(456.604 203.205) scale(66.7152 66.7152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15054,
    stopColor: "#15344D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22655,
    stopColor: "#395369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36276,
    stopColor: "#738696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49443,
    stopColor: "#A4B0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61823,
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73226,
    stopColor: "#E5E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83308,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91003,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1375_1010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(456.604 106.695) scale(66.7152 66.7152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15054,
    stopColor: "#15344D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22655,
    stopColor: "#395369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36276,
    stopColor: "#738696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49443,
    stopColor: "#A4B0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61823,
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73226,
    stopColor: "#E5E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83308,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91003,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1375_1010",
    x1: 487.082,
    y1: 187.671,
    x2: 431.332,
    y2: 207.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1375_1010",
    x1: 444.665,
    y1: 214.819,
    x2: 444.665,
    y2: 155.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1375_1010",
    x1: 418.691,
    y1: 236.156,
    x2: 454.441,
    y2: 171.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1375_1010",
    x1: 426.357,
    y1: 197.355,
    x2: 465.732,
    y2: 176.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11095,
    stopColor: "#DEE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67581,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1375_1010",
    x1: 390,
    y1: 125.099,
    x2: 499.55,
    y2: 125.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23529,
    stopColor: "#B97800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45989,
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53019,
    stopColor: "#D8A232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60651,
    stopColor: "#B4811C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67837,
    stopColor: "#9B690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74324,
    stopColor: "#8B5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79501,
    stopColor: "#865600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82876,
    stopColor: "#936208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89144,
    stopColor: "#B6831D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97556,
    stopColor: "#EDB73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC74A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1375_1010",
    x1: 444.664,
    y1: 77.8721,
    x2: 444.664,
    y2: 171.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01202,
    stopColor: "#FDE69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05297,
    stopColor: "#FBEBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09878,
    stopColor: "#FAEFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1506,
    stopColor: "#F9F3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21186,
    stopColor: "#F8F5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29173,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45939,
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53242,
    stopColor: "#EFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69272,
    stopColor: "#DBBE89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85625,
    stopColor: "#C59232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1375_1010",
    x1: 417.522,
    y1: 85.6894,
    x2: 479.551,
    y2: 176.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01202,
    stopColor: "#FDE69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05297,
    stopColor: "#FBEBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09878,
    stopColor: "#FAEFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1506,
    stopColor: "#F9F3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21186,
    stopColor: "#F8F5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29173,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45939,
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53242,
    stopColor: "#EFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69272,
    stopColor: "#DBBE89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85625,
    stopColor: "#C59232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1375_1010",
    x1: 439.769,
    y1: 97.368,
    x2: 448.197,
    y2: 97.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23529,
    stopColor: "#B97800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45989,
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53019,
    stopColor: "#D8A232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60651,
    stopColor: "#B4811C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67837,
    stopColor: "#9B690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74324,
    stopColor: "#8B5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79501,
    stopColor: "#865600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82876,
    stopColor: "#936208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89144,
    stopColor: "#B6831D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97556,
    stopColor: "#EDB73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC74A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1375_1010",
    x1: 439.769,
    y1: 155.866,
    x2: 448.197,
    y2: 155.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23529,
    stopColor: "#B97800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45989,
    stopColor: "#FFC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53019,
    stopColor: "#D8A232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60651,
    stopColor: "#B4811C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67837,
    stopColor: "#9B690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74324,
    stopColor: "#8B5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79501,
    stopColor: "#865600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82876,
    stopColor: "#936208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89144,
    stopColor: "#B6831D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97556,
    stopColor: "#EDB73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC74A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1375_1010",
    x1: 30,
    y1: 112,
    x2: 214,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#F6BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547145,
    stopColor: "#865802",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823367,
    stopColor: "#F6BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1375_1010",
    x1: 30,
    y1: 142.5,
    x2: 146,
    y2: 142.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#F6BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547145,
    stopColor: "#865802",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823367,
    stopColor: "#F6BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1375_1010",
    x1: 393,
    y1: 357.5,
    x2: 524,
    y2: 357.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260041,
    stopColor: "#B97E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47666,
    stopColor: "#F1BE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754078,
    stopColor: "#83510F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E0A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1375_1010",
    x1: 392.5,
    y1: 356.5,
    x2: 394.5,
    y2: 358.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992711,
    stopColor: "#EBB84F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1375_1010",
    x1: 522.5,
    y1: 356.5,
    x2: 524.5,
    y2: 358.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992711,
    stopColor: "#EBB84F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1375_1010",
    x1: 30,
    y1: 218.5,
    x2: 208,
    y2: 218.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6BE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260041,
    stopColor: "#B97E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47666,
    stopColor: "#F1BE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754078,
    stopColor: "#83510F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E0A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBg);
export default __webpack_public_path__ + "static/media/CertificateBg.00c1a8bc68cbca0c4defc240b84405b8.svg";
export { ForwardRef as ReactComponent };